export default __webpack_public_path__ + "static/media/2.04a5b8f6.png";